import React, { useState, useMemo } from 'react'
import { Box, Alert, LinearProgress } from '@mui/material'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import PageTitle from '../../../components/PageTitle'
import { Pill, SectionCard, ActionIconBtn } from '../components/common'
import DataTable from '../components/Tables'
import ProposalDetailModal from '../components/ProposalDetailModal'
import { useListProposalsQuery } from '../../../redux/d2cApiSlice'
import { proposalRow, inGroup } from '../apiMap'

export default function SLHistory() {
  const [detail, setDetail] = useState(null)
  const { data, isLoading, isError, error } = useListProposalsQuery({ page: 0, size: 100 })
  const rows = useMemo(
    () => (Array.isArray(data) ? data.map(proposalRow).filter((r) => inGroup('recent', r.apiStatus)) : [])
      .sort((a, b) => new Date(b.raw?.updatedAt || 0) - new Date(a.raw?.updatedAt || 0)), // most recently changed first
    [data],
  )
  const columns = [
    { key: 'brand', label: 'Brand', render: (r) => <b>{r.brand}</b> },
    { key: 'card', label: 'Card' },
    { key: 'band', label: 'Band' },
    { key: 'outcome', label: 'Outcome', render: (r) => <Pill label={r.outcome} styleKey={r.outcomeKey} /> },
    { key: 'closed', label: 'Closed' },
    { key: 'a', label: 'Action', align: 'right', render: (r) => <ActionIconBtn title="Open rate card & T&Cs" onClick={() => setDetail(r)}><VisibilityOutlinedIcon fontSize="small" /></ActionIconBtn> },
  ]
  return (
    <Box sx={{ px: 3 }}>
      <PageTitle>Proposal History</PageTitle>
      {isLoading && <LinearProgress sx={{ my: 1 }} />}
      {isError && <Alert severity="error" sx={{ my: 1 }}>{error?.message || 'Failed to load history.'}</Alert>}
      <SectionCard title="Proposal History" subtitle="Every closed proposal. Click any row to open the full rate card and T&Cs exactly as the client saw them, with the working files attached.">
        <DataTable columns={columns} rows={rows} onRowClick={(r) => setDetail(r)} getRowKey={(r) => r.id} emptyText={isLoading ? 'Loading…' : 'No closed proposals yet'} />
      </SectionCard>
      <ProposalDetailModal open={!!detail} proposal={detail} onClose={() => setDetail(null)} />
    </Box>
  )
}
